import { Table } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { findVendorStatusTitle } from '../../../library/constants/vendor-statuses.js';
import { getTimeAgo } from '../../../library/utils';

const AuditTrail = ({ logs }) => {
    return (
        <Table
            columns={[
                {
                    title: 'Date',
                    dataIndex: 'date',
                    render: getTimeAgo
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    render: findVendorStatusTitle
                },
                {
                    title: 'User',
                    dataIndex: 'user',
                },
                {
                    title: 'Message',
                    dataIndex: 'message',
                },
            ]}
            dataSource={logs}
            rowKey="id"
            pagination={{ hideOnSinglePage: true }}
        />
    )
}
AuditTrail.propTypes = {
    logs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        createdAt: PropTypes.string.isRequired,
        status: PropTypes.string,
        message: PropTypes.string.isRequired,
        user: PropTypes.object,
    }))
}
export default AuditTrail